import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
//  Dashboard React Context Provider
import { VisionUIControllerProvider } from "context";
import store from "lib/store/store";
import "./index.css";
import "reactflow/dist/style.css";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <VisionUIControllerProvider>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Provider store={store}>
          <Toaster position="top-center" reverseOrder={false} />
          <App />
        </Provider>
      </GoogleOAuthProvider>
    </VisionUIControllerProvider>
  </BrowserRouter>
);
